/* Star ratings on Convermax product cards. See snippets/custom__convermax-rating.liquid. */
(() => {
  const config = window.cmProductRating;
  const template = document.getElementById('cm-product-rating-icons');
  if (!config || !template) return;

  const icons = {};
  template.content.querySelectorAll('[data-star]').forEach((el) => {
    icons[el.dataset.star] = el.innerHTML.trim();
  });

  const stripQuery = (url) => (url || '').split(/[?#]/)[0];

  // Kept across searches so cards from earlier pages (infinite scroll) still resolve.
  const reviewsByUrl = new Map();

  const cacheResponse = () => {
    const convermax = window.Convermax;
    if (!convermax || typeof convermax.getSearchResponse !== 'function') return;

    const response = convermax.getSearchResponse();
    const items = response && response.items && (response.items._items || response.items);
    if (!items || typeof items.forEach !== 'function') return;

    items.forEach((entry) => {
      const item = entry && (entry._item || entry);
      if (!item || !item.url) return;
      reviewsByUrl.set(stripQuery(item.url), {
        average: Number(item.review_average) || 0,
        count: Number(item.review_count) || 0
      });
    });
  };

  // Same rounding as snippets/product-rating.liquid
  const starsHtml = (average) => {
    const decimal = average % 1;
    let partial = decimal >= 0.3 && decimal <= 0.7 ? 'half' : decimal > 0.7 ? 'full' : 'empty';
    let html = '';

    for (let i = 1; i <= 5; i++) {
      if (average >= i) {
        html += icons.full;
      } else {
        html += icons[partial];
        partial = 'empty';
      }
    }

    return html;
  };

  const buildBadge = (url, { average, count }) => {
    const badge = document.createElement('a');
    badge.className = 'product-item-meta__reviews-badge text--small';
    badge.href = url;
    badge.dataset.cmRating = url;

    const caption = (count === 1 ? config.one : config.other).replace('[count]', count);
    badge.innerHTML =
      '<div class="rating">' +
        `<div class="rating__stars" role="img" aria-label="${config.label.replace('[value]', average)}">${starsHtml(average)}</div>` +
        `<span class="rating__caption">${caption}</span>` +
      '</div>';

    return badge;
  };

  const update = () => {
    cacheResponse();

    document.querySelectorAll('.cm_SearchResult product-item').forEach((card) => {
      const meta = card.querySelector('.product-item-meta');
      const title = meta && meta.querySelector('.product-item-meta__title');
      if (!title) return;

      const url = stripQuery(title.getAttribute('href'));
      const existing = meta.querySelector('[data-cm-rating]');

      // Convermax re-renders cards in place, so re-check the badge still belongs to this product.
      if (existing && existing.dataset.cmRating === url) return;
      if (existing) existing.remove();

      const reviews = reviewsByUrl.get(url);
      if (reviews && reviews.count > 0) meta.appendChild(buildBadge(url, reviews));
    });
  };

  // setTimeout rather than requestAnimationFrame, which never fires in a background tab.
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      update();
    }, 50);
  };

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
